import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Branding System
import './styles/Branding.css';
import { loadBranding } from './utils/brandingLoader';

// Performance
import reportWebVitals from './reportWebVitals';

// Load default + stored business branding
async function boot(){
  await loadBranding("default");

  const saved = localStorage.getItem("businessId");
  if(saved){
    await loadBranding(saved);
  }
}

boot().then(()=>{
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  );
});

reportWebVitals();
